// extracted by mini-css-extract-plugin
export default {"container":"NewsHeader_container__AJ49+","separator":"NewsHeader_separator__1GLhl","author":"NewsHeader_author__OdN0m"};